import { CultureInfo } from '../culture-info.model';
import { CultureInfoUz } from './uz';

/**
 * @ignore
 */
export const CultureInfoUzLatn: CultureInfo = {
  name: 'uz-Latn',
  displayName: 'Uzbek (Latin)',
  iso3LanguageCode: 'uzb',
  iso2LanguageCode: 'uz',
  ietfLanguageTag: 'uz-Latn',
  parent: CultureInfoUz
};
